import HomePage from 'province-app/home';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import provinceStore from 'province-app/redux/province.store';
import { provinceStoreContext } from 'province-app/redux/province.store';

function ProvinceApp() {
  return (
    <Provider store={provinceStore} context={provinceStoreContext}>
      <HomePage />
    </Provider>
  );
}

export default ProvinceApp;
